import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { UserRoles, RestaurantNotificationEventType } from 'types';
import { restaurantNotificationEvents } from 'appConstants';
import { useRoleAccess } from 'hooks/useRoleAccess';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const PushTypeSelect: React.FC = () => {
	const { t } = useTranslation('form');
	const allowableRoles = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	const restaurantManagerPushes = [
		RestaurantNotificationEventType.PushUpdateRestaurantSettings,
		RestaurantNotificationEventType.PushUpdateRestaurantMenu,
		RestaurantNotificationEventType.PushPriceUpdate,
		RestaurantNotificationEventType.PushUpdateTeasers,
	];

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		const options = allowableRoles ? restaurantNotificationEvents : restaurantManagerPushes;

		return options.map((el) => ({
			id: el,
			name: t(el),
		}));
	}, [t, allowableRoles]);

	return (
		<FormSelect
			testId="PushTypeSelect"
			name="pushType"
			label="pushTypeLabel"
			options={mappedOptions}
			withSearch={true}
			disabled={true}
		/>
	);
};

export default React.memo(PushTypeSelect);
